export default {"src":"/login-app/[GIT_HASH]/_next/static/media/trending_flat.e152f7d4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};